import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Row, Button } from 'reactstrap';
import { fetchCoursesRequest, fetchStudentsRequest, addStudentRequest, getRoles } from 'store/actions';
import CreateStudent from './CreateStudent';
import Breadcrumb from 'components/Common/Breadcrumb2';
import StudentTable from './StudentTable';
import Cookies from 'js-cookie';

const StudentList = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();

  const students = useSelector((state) => state.Student.students);
  const courses = useSelector((state) => state.Course.courses);
  const roles = useSelector((state) => state.Role.roles);

  const loading = useSelector((state) => state.Student.loading);
  const error = useSelector((state) => state.Student.error);

  const permissions = JSON.parse(localStorage.getItem('permissions'));
  const hasAddPermission = permissions?.some(item => item?.permission_name === "Add Student");

  useEffect(() => {
    dispatch(fetchCoursesRequest());
  }, [dispatch]);

  const handleSubmit = (data, onClose) => {
    dispatch(addStudentRequest(data, onClose));
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      {/* Modal for creating or editing students */}
      <CreateStudent
        visible={isOpen}
        onSubmit={handleSubmit}
        handleClose={handleClose}
        roles={roles?.data?.filter(role => role?.role_name?.toLowerCase() === "student")} // only Student role
        courses={courses?.data}
      />

      <div className="page-content container-fluid">
        {/* Page header */}
        <div className="d-flex justify-content-between align-items-center mx-3">
          <Breadcrumb
            title="Students"
            breadcrumbItems={[
              { title: 'Dashboard', link: '/dashboard' },
              { title: 'Students', link: '#' }
            ]}
          />

          {hasAddPermission && (
            <Button
              className="bg-primary text-white d-flex justify-content-center gap-1 align-items-center"
              onClick={() => setIsOpen(true)}
            >
              <i className="ti-plus"></i> Add New
            </Button>
          )}
        </div>

        {/* Student list table */}
        <StudentTable
          courses={courses?.data}
          students={students?.data || []}
          totalrows={students?.total}
          loading={loading}
          error={error}
        />
      </div>
    </>
  );
};

export default StudentList;
